import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { EditionContractPublisherListStore } from "../../store/EditionContractPublisherListStore";

type EditionContractPublisherListDialogsProps = {
  store: EditionContractPublisherListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de EditionContractPublisher.
 * Separado para mantener EditionContractPublisherListPage más limpio.
 */
export const EditionContractPublisherListDialogs: React.FC<EditionContractPublisherListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
